import React  from 'react';
import './App.css';
import './Notebook.css';
import NotebookLang from './NotebookLang.json';

import { useNavigate } from "react-router-dom";

class NotebookDoc extends React.Component {

	constructor(props) {

		super(props);

		this.state = {
			notebookJsonObj: null,
			sourceArray: null,
			creatingDocYN: false,
			fileText: "",
		}
	}

	async componentDidMount() {

		var notebookID = this.props.notebookID;
		var docType = this.props.docType;

		var notebookJsonObj = await this.props.serverGetNotebookData(notebookID);
		this.setState({
			notebookJsonObj: notebookJsonObj,
			docType: docType,
		});

		var notebookStorageID = notebookJsonObj.storageID;		
		//var docType2 = docType.toLowerCase();

		var filenameExt = "notebook-" + docType + ".txt";
		var fileText = await this.props.serverStorageProxy(notebookStorageID, filenameExt);

		if (fileText === "") {
			this.setState({creatingDocYN: true});
			await this.serverCreateDoc(notebookID, notebookStorageID, docType, this.props.userID);
			this.setState({creatingDocYN: false});
			fileText = await this.props.serverStorageProxy(notebookStorageID, filenameExt);
		}

		this.setState({
			fileText: fileText,
		});
	}
	
	async serverCreateDoc(notebookID, storageID, docType, userID) {

		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/createdoc?notebookid=" + notebookID;
		url = url + "&storageid=" + encodeURIComponent(storageID);
		url = url + "&doctype=" + encodeURIComponent(docType);
		url = url + "&userid=" + userID;

		var responseText = "";
		
		try {
			var res = await fetch(url);
			responseText = await res.text();
		} catch (err) {
		}

		return responseText;
	}
	
	onClickBackToNotebook() {
		var navigate = this.props.navigate;
  		navigate("/notebook");
	}
	
	renderCreatingDoc() {
		
		var creatingDocYN = this.state.creatingDocYN;
		if (!creatingDocYN) {
			return;
		}
		
		return (
			<div>
				{this.props.getLang(NotebookLang, "creatingDocPleaseWait")}
			</div>
		);
	}
	
	renderFileText() {

		var creatingDocYN = this.state.creatingDocYN;
		if (creatingDocYN) {
			return;
		}

		var fileText = this.state.fileText;
		var fileTextJsx = this.props.convertTextToJsx(fileText);

		return (
			<div>
				{fileTextJsx}
			</div>
		);
	}

	render() {

		var notebookJsonObj = this.state.notebookJsonObj;
		if (notebookJsonObj === null) {
			return;
		}

		var notebookID = this.props.notebookID;
		var docType = this.props.docType;
		var notebookTitle = notebookJsonObj.title;
		
		var docTypeString = this.props.getLang(NotebookLang, docType);
		
		return (
			<div className="NotebookDocTopContainer">
				<div style={{height: "12px"}}></div>
				<div className="NotebookDocTitle"><b>{this.props.getLang(NotebookLang, "notebook")}</b>: {notebookTitle}</div>
				<div className="NotebookDocTitle"><b>{this.props.getLang(NotebookLang, "doctype")}</b>: {docTypeString}</div>
				<hr className="NotebookCustomLine" />
				{this.renderCreatingDoc()}
				{this.renderFileText()}
				<div style={{height: "20px"}}></div>
				<button className="NotebookGreyButton" onClick={() => this.onClickBackToNotebook()}>{this.props.getLang(NotebookLang, "backToNotebook")}</button>
				<div style={{height: "30px"}}></div>
			</div>
		);
	}
}

export default function NotebookDocFunction(props) {
	const navigate = useNavigate();
	return <NotebookDoc {...props} navigate={navigate} />;
}

